<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <div>
            <FormInput :label="dniLabel" name="dni" rules="required" data-cy="dni" v-model="abonado.dni" :disabled="disabled" />
            <FormInput class="mb-3 mb-lg-4" v-if="!manager.renovar_abono_solo_con_dni" :label="$t('formularios.n_abonado_anterior', {abonado: teatro.texto_abonado.toUpperCase()})" name="n_abonado_antiguo" rules="required" v-model="abonado.n_abonado_antiguo" :disabled="disabled" />
        </div>
        
        <button type="submit" class="button large-button" :class="{'effect-button': !disabled}" :disabled="disabled"><span>{{ $t('renovar_abono.renovar') }}</span></button>
    </ValidationObserver>
</template>

<script>
    import { TEATRO_HASH_RIBADESELLA } from '@/constants/teatros';

    export default {
        props: {
            abonado: { type: [Object, Array], required: true },
            disabled: { type: Boolean, default: false }
        },
        data() {
            return {
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            manager() {
                return this.$store.getters.getFooter;
            },
            teatro(){
                return this.$store.getters.getTeatro;
            },
            dniLabel(){
                // Bollullos CF
                if(this.teatro.hash === "s5ay4YoJIwJxO6Aq0lAi") {
                    return "NOMBRE Y APELLIDOS (Por favor, introduzca el texto en MAYÚSCULA)";
                }

                // Club Melilla Baloncesto
                if(this.teatro.hash === "TjXhLW5OHYFHNv58ignc") {
                    return "DNI O APELLIDOS (en mayúscula)";
                }

                // Calamocha
                if(this.teatro.hash === 'ktEQfwmffBlx37Ws043A') {
                    return this.$t('formularios.apellidos');
                }

                // Ribadesella
                if(this.teatro.hash === TEATRO_HASH_RIBADESELLA) {
                    return this.$t('formularios.nombre_apellidos');
                }

                return this.$t('formularios.dni');
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.terminar();
                }
            },
            terminar() {
                this.$emit('terminado');
            }
        },
    }
</script>